import dayjs from "dayjs";

import { ToggleButtons } from "@aclymatepackages/atoms";
import { Box, Typography } from "@mui/material";

import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";
import {
  useCachedFirebaseCrud,
  useAccountData
} from "../../../helpers/firebase";

const EditStartDateButton = ({ disabled }) => {
  const [{ startDate }] = useAccountData();

  const { updateAccountData } = useCachedFirebaseCrud();
  const { isSimulation } = usePlatformLayoutContext();

  // Anchor at noon, not midnight: a Jan 1 00:00 value shifts to Dec 31 of the
  // prior year when the instant is read in a US timezone, which makes the
  // selected year render one year too low.
  const onYearSelect = (year) =>
    updateAccountData({ startDate: new Date(year, 0, 1, 12) });

  const yearsArray = [...new Array(5)].map(
    (_, idx) => dayjs().year() - (idx + 1)
  );

  return (
    <Box>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
        Choose your accounting start year
      </Typography>
      <ToggleButtons
        value={startDate && dayjs(startDate).year()}
        buttons={yearsArray.map((year) => ({ value: year, name: year }))}
        onChange={onYearSelect}
        disabled={disabled || isSimulation}
      />
    </Box>
  );
};
export default EditStartDateButton;
